import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { AutoPayLabel, Icon, toast } from '@livable/saas-react-components';
import { Button, Grid, List, ListItem, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { BalanceStatus } from 'src/components/general/BalanceStatus';
import PostPaymentModal from 'src/components/transactions/PostPaymentModal';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const Balance = observer(props => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const accountId = props.accountId,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    residentModal = props.residentModal,
    status = props.status,
    handleRefreshTrigger = props.handleRefreshTrigger;
  const currentAccountId = accountId || (residentModal === null || residentModal === void 0 ? void 0 : residentModal.accountId);
  const currentPropertyId = propertyId || (residentModal === null || residentModal === void 0 ? void 0 : residentModal.propertyId);
  const currentResidencyId = residencyId || (residentModal === null || residentModal === void 0 ? void 0 : residentModal.residencyId);
  const residencyOverview = store.residencies.residencyOverview;
  const isConvergentBillingResident = (residencyOverview === null || residencyOverview === void 0 ? void 0 : residencyOverview.residencyId) === currentResidencyId && (residencyOverview === null || residencyOverview === void 0 ? void 0 : residencyOverview.effectiveConvergentBilling);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const handleSendBalanceRemainder = async () => {
    const resp = await store.payment.sendBalanceRemainderAsync.run({
      accountId: currentAccountId
    });
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully sent']
      });
    }
  };
  return /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, !residentModal && /*#__PURE__*/React.createElement(ListItem, {
    className: "".concat(classes.tenantName, " ").concat(classes[status])
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "wallet"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('unit_modal.balance_overview')))), (!residentModal || residentModal && !store.company.companyFeatureStore.disableAccountOverview) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('unit_modal.payments_received_since'), " in ", store.payment.residentBalance.lastPaymentReceivedAtDateOnly), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "$", Number(store.payment.residentBalance.previousStatementPayments).toFixed(2))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('unit_modal.previous_statement_balance')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "$", Number(store.payment.residentBalance.previousStatementBalance).toFixed(2))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('unit_modal.current_charges')), /*#__PURE__*/React.createElement(AutoPayLabel, {
    isOn: store.payment.isAccountAutoPay,
    isSideText: true
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "$", Number(store.payment.residentBalance.currentCharges).toFixed(2))), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('unit_modal.due_by'), " ", store.payment.residentBalance.dueOnDateOnly, ' '), /*#__PURE__*/React.createElement("div", {
    className: classes.balance
  }, /*#__PURE__*/React.createElement(BalanceStatus, {
    status: status
  }))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "$", Number(store.payment.residentBalance.currentBalance).toFixed(2)))), /*#__PURE__*/React.createElement("div", {
    className: classes.listFooter
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, residentModal && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(Button, {
    target: "_blank",
    component: RouterLink,
    to: "/resident_acount?id=".concat(residentModal.residencyId, "&accountId=").concat(residentModal.accountId, "&propertyId=").concat(residentModal.propertyId),
    variant: "contained",
    size: "small",
    'custom-attribute': '232-balance'
  }, t('unit_modal.open_account_profile'))), !store.company.companyFeatureStore.disablePostPayment && !isConvergentBillingResident && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setIsOpen(true),
    size: "small",
    variant: "contained",
    'custom-attribute': '233-balance'
  }, t('resident_account.post_payment')), /*#__PURE__*/React.createElement(PostPaymentModal, {
    accountId: currentAccountId,
    handleClose: () => setIsOpen(false),
    isOpen: isOpen,
    propertyId: currentPropertyId,
    handleRefreshTrigger: handleRefreshTrigger
  })), !store.company.companyFeatureStore.disableSendReminder && !isConvergentBillingResident && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    disabled: store.payment.sendBalanceRemainderAsync.inProgress,
    onClick: handleSendBalanceRemainder,
    'custom-attribute': '234-balance'
  }, t('unit_modal.send_balance_reminder'))))));
});